import { ref } from 'vue'
import axios from 'axios'

const BASE_URL = 'https://auth.primeoptions.io'

export default function useApiFetch(endpoint: string, options: any = {}) {
  const data = ref<any>(null)
  const error = ref<any>(null)

  const token = localStorage.getItem('token')
  const isFormData = options?.body instanceof FormData
  const defaultConfig = {
    method: options?.method || 'GET',
    ...options,
    headers: {
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      ...(token && { Authorization: `${token}` }),
      ...(options.headers || {}),
    },
    url: `${BASE_URL}${endpoint}`,
    data: isFormData ? options.body : options?.body ? JSON.parse(options.body) : undefined,
  }

  return new Promise<{ data: typeof data; error: typeof error }>((resolve) => {
    axios(defaultConfig)
      .then((response) => {
        data.value = response.data
        resolve({ data, error })
      })
      .catch((err) => {
        error.value = err.response || err
        resolve({ data, error })
      })
  })
}
